<template>
  <v-card class="assignment-form">
    <div class="d-flex align-center justify-space-between assignment-form__title">
      <p class="assignment-form__title--left">
        Assignment <span v-if="gIsEditing && checkIfFieldUpdated">[UNSAVED CHANGES]</span>
        <span v-if="!gIsEditing">[DRAFT]</span>
      </p>
      <div class="d-flex align-center assignment-form__title--right">
        <p class="assignment-form__title--right--text ml-5" v-if="gIsEditing && windowWidth > 925">
          Created on {{ createdDate && formatDateForTitle(createdDate) }}
          {{ createdDate && updatedDate && (updatedDate[0] !== createdDate[0] || updatedDate[1] !== createdDate[1] || updatedDate[2] !== createdDate[2]) ? ', last edited ' + formatDateForTitle(updatedDate) : '' }}
        </p>
        <!-- <p class="assignment-form__title--right--text ml-5" v-if="!gIsEditing && windowWidth > 925">The task is in DRAFT. To save your changes, publish the task.</p> -->
        <button v-if="createAssignmentLoader"
          class="assignment-form__title--right--publish ml-2"
          disabled>
            Saving…
        </button>
        <button v-else-if="!gIsEditing"
          class="assignment-form__title--right--publish ml-2"
          @click.prevent="publishAssignment">
            Publish Assignment
        </button>
        <button v-else-if="gIsEditing && checkIfFieldUpdated"
          class="assignment-form__title--right--publish ml-2"
          @click.prevent="publishAssignment">
            Update
        </button>
        <div class="assignment-form__title--right--delimetr ml-5"></div>
        <div class="assignment-form__title--right--icon ml-5">
          <v-btn
            text
            small
            @click.native.stop.prevent="openSlackForm(itemToEdit)">
            <pmdashboard_table_icons
              :icon="'pmdashboard_slack'"
              />
          </v-btn>
        </div>
        <div class="assignment-form__title--right--icon ml-5">
          <v-btn
            text
            small
            @click.native.stop.prevent="openSettingsMenu">
            <pmdashboard_table_icons
              :icon="'pmdashboard_ellipsis-solid'"
              />
          </v-btn>
          <div
            v-if="assignmentSettingsMenu"
            class="assignment-form__title--right--menu"
            v-click-outside="closeSettingsMenu">
            <div class="assignment-form__title--right--menu--items">
              <p @click="deleteTaskMenuOpen">Delete assignment</p>
            </div>
          </div>
        </div>
        <div class="assignment-form__title--right--close ml-2">
          <v-btn
            text
            small
            @click="closeForm">
            <pmdashboard_table_icons
              :icon="'pmdashboard_close_black'"
              />
          </v-btn>
        </div>
      </div>
    </div>
    <v-container class="assignment-form__assignment pa-0" fluid>
      <div class="row-styles w-100 ma-0">
        <div
          :style="windowWidth <= 1286 ? { width: '100%' } : { width: 'calc(100% - 420px)' }"
          class="assignment-form__assignment--content-left" 
          :class="{ 'pa-1': windowWidth > 1286,
            'pa-0': windowWidth <= 1286
           }">
          <div class="d-flex w-100">
            <div style="width: 100%;" 
              class="scrollable-col animated-section"
              v-show="settingsSection === 'Details'"
              :style="dynamicHeightStyle">
              <div class="d-flex flex-column assignment-form__assignment--title pa-6 ml--12px"  
                style="
                margin-top: 0;
                padding-top: 50px !important;
                "
              >

                <!-- Cue Task ID + Cue Assignment ID + External Assignment ID -->
                <div class="d-flex w-100 relative">
                  <p class="assignment-form--id--text d-inline">{{ headerDropdown.find(item => item.show).title }}: </p>
                  <v-btn
                    text
                    small
                    class="assignment-form--id--button"
                    @click.native.stop.prevent="toggleHeaderDropdown">
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_arrow_down'"
                      />
                  </v-btn>
                  <v-btn
                    v-if="headerDropdown.find(item => item.show).value"
                    text
                    small
                    class="assignment-form--id--button"
                    @click.native.stop.prevent="copyTaskId">
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_copy'"
                      />
                  </v-btn>
                  <p style="width: 70%" class="mb-0 assignment-form--id--text">
                    {{ headerDropdown.find(item => item.show).value ? headerDropdown.find(item => item.show).value : 'no value yet' }}
                  </p>
                  <div class="assignment-form__header--dropdown"
                    v-click-outside="toggleHeaderDropdown"
                    v-if="headerDropdownState">
                    <div class="dropdown-item"
                      v-for="(item, index) in headerDropdown"
                      :key="index"
                      @click.prevent="selectDropdownItem(item)">
                      <div class="dropdown-item--left">
                        <p class="dropdown-item--left--text">{{ item.title }}</p>
                        <div class="dropdown-item--left--value">
                          <v-btn
                            v-if="item.value"
                            text
                            small
                            class="assignment-form--id--button"
                            @click.native.stop.prevent="copyTaskId">
                            <pmdashboard_table_icons
                              :icon="'pmdashboard_copy'"
                              />
                          </v-btn>
                          <p style="width: 90%" class="mb-0 dropdown-item--left--value--text">{{ item.value ? item.value : 'no value yet' }}</p>
                        </div>
                      </div>
                      <div class="dropdown-item--right">
                        <v-icon 
                          v-if="item.show"
                          size="20"
                          style="margin-left: 3.5px;">
                            mdi-check
                        </v-icon>
                      </div>
                    </div>
                  </div>
                  <!-- <div
                    v-if="!isEditing.includes('editableInput-assignmentForm.taskId')"
                    class="mb-0 assignment-form--id w-100 bradius-4"
                    :class="{
                      'hover': isHovered.includes('editableInput-assignmentForm.taskId'),
                      'empty-p-field-assignmentForm.taskId': !assignmentForm.taskId,
                      'fullfield-p-field-assignmentForm.taskId': assignmentForm.taskId
                    }"
                    style="position: relative;"
                    @mouseover="isHoveredOn('editableInput-assignmentForm.taskId')"
                    @mouseleave="isHoveredOff('editableInput-assignmentForm.taskId')"
                    @click="startEditing('editableInput-assignmentForm.taskId')"
                  >
                    <p style="width: 90%" class="mb-0">
                      {{ assignmentForm.taskId ? assignmentForm.taskId : '-' }}
                    </p>
                    <span
                      @click.prevent.stop="assignmentForm.taskId = ''"
                      class="assignment-form__clear assignment-form__clear--title"
                      v-if="isHovered.includes('editableInput-assignmentForm.taskId') && assignmentForm.taskId"
                    >
                      <pmdashboard_table_icons
                        :icon="'pmdashboard_clear_text_field'"
                        class="assignment-form__clear-text d-block"
                      />
                    </span>
                  </div>
                  <input
                    v-else
                    type="text"
                    ref="editableInput-assignmentForm.taskId"
                    v-model="assignmentForm.taskId"
                    @blur="stopEditing('editableInput-assignmentForm.taskId')"
                    @keydown.enter="stopEditing('editableInput-assignmentForm.taskId')"
                    :class="{ hover: true }"
                    class="input-field input-field-assignmentForm.taskId w-100 bradius-4"
                  /> -->
                </div>

                <!-- Assignment Title -->
                <div class="d-flex align-center w-100 assignment-form--title">
                  <v-btn
                    text
                    small
                    class="assignment-form--title--button"
                    @click.native.stop.prevent="copyAssignmentTitle">
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_copy'"
                      />
                  </v-btn>
                  <div
                    v-if="!isEditing.includes('editableInput-assignmentTitle')"
                    class="mb-0 w-100 assignment-form--title--div bradius-4"
                    :class="{
                      'hover': isHovered.includes('editableInput-assignmentTitle'),
                      'empty-p-field-assignmentTitle': !assignmentForm.assignmentTitle,
                      'fullfield-p-field-assignmentTitle': assignmentForm.assignmentTitle,
                    }"
                    style="position: relative;"
                    @mouseenter="isHoveredOn('editableInput-assignmentTitle')"
                    @mouseleave="isHoveredOff('editableInput-assignmentTitle')"
                    @click="startEditing('editableInput-assignmentTitle')"
                  >
                    <p style="width: 90%; white-space: normal; word-wrap: break-word;" class="mb-0">
                      {{ assignmentForm.assignmentTitle ? assignmentForm.assignmentTitle : 'No Name' }}
                    </p>
                    <span
                      @click.stop.prevent="updateAssignmentData({ field: 'assignmentTitle', data: '' })"
                      class="assignment-form__clear assignment-form__clear--title"
                      v-if="isHovered.includes('editableInput-assignmentTitle') && assignmentForm.assignmentTitle"
                    >
                      <pmdashboard_table_icons
                        :icon="'pmdashboard_clear_text_field'"
                        class="assignment-form__clear-text d-block"
                      />
                    </span>
                  </div>
                  <input
                    v-else
                    type="text"
                    ref="editableInput-assignmentTitle"
                    v-model="assignmentTitleValue"
                    @blur="stopEditing('editableInput-assignmentTitle')"
                    @keydown.enter="stopEditing('editableInput-assignmentTitle')"
                    :class="{ hover: true }"
                    class="input-field input-field-assignmentTitle w-100 bradius-4"
                  />
                </div>

                <div class="d-flex w-100">
                  <!-- Request Type -->
                  <div class="d-flex relative flex-shrink-0">
                    <p class="assignment-form--id--text d-inline">Request Type: </p>
                    <v-btn
                      text
                      small
                      class="assignment-form--id--button"
                      @click.native.stop.prevent="toggleRequestTypeDropdown">
                      <pmdashboard_table_icons
                        :icon="'pmdashboard_arrow_down'"
                        />
                    </v-btn>
                    <p class="mb-0 assignment-form--id--text"
                      @click.prevent="toggleRequestTypeDropdown">
                      {{ assignmentForm.requestType ? assignmentForm.requestType : 'no value yet' }}
                    </p>
                    <div class="assignment-form__header--dropdown dropdown__request"
                      v-click-outside="toggleRequestTypeDropdown"
                      v-if="requestTypeDropdown">
                      <div class="dropdown-item"
                        v-for="(item, index) in requestTypeOptions"
                        :key="index"
                        @click.prevent="selectRequestTypeDropdownItem(item)">
                        <div class="dropdown-item--left">
                          <p class="dropdown-item--left--text">{{ item }}</p>
                        </div>
                        <div class="dropdown-item--right">
                          <v-icon 
                            v-if="assignmentForm.requestType === item"
                            size="20"
                            style="margin-left: 3.5px;">
                              mdi-check
                          </v-icon>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Assignment Type -->
                  <div class="d-flex relative flex-grow-1">
                    <p class="assignment-form--id--text d-inline">| Assignment Type: </p>
                    <v-btn
                      text
                      small
                      class="assignment-form--id--button"
                      @click.native.stop.prevent="toggleAssignmentTypeDropdown">
                      <pmdashboard_table_icons
                        :icon="'pmdashboard_arrow_down'"
                        />
                    </v-btn>
                    <p style="width: 70%" class="mb-0 assignment-form--id--text"
                      @click.prevent="toggleAssignmentTypeDropdown">
                      {{ assignmentForm.assignmentType ? assignmentForm.assignmentType : 'no value yet' }}
                    </p>
                    <div class="assignment-form__header--dropdown dropdown__request"
                      v-click-outside="toggleAssignmentTypeDropdown"
                      v-if="assignmentTypeDropdown">
                      <div class="dropdown-item"
                        v-for="(item, index) in requestTypeOptions"
                        :key="index"
                        @click.prevent="selectAssignmentTypeDropdownItem(item)">
                        <div class="dropdown-item--left">
                          <p class="dropdown-item--left--text">{{ item }}</p>
                        </div>
                        <div class="dropdown-item--right">
                          <v-icon
                            v-if="assignmentForm.assignmentType === item"
                            size="20"
                            style="margin-left: 3.5px;">
                              mdi-check
                          </v-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- GEOs -->
                <div class="d-flex w-100 mt-3">
                  <div class="d-flex relative flex-shrink-0">
                    <p class="mb-0 assignment-form--geo"
                      @click.prevent="toggleSourceGeoDropdown">
                      {{ assignmentForm.sourceGeo ? assignmentForm.sourceGeo : 'No Source GEO' }}
                    </p>

                    <div
                      class="assignment-form__header--dropdown dropdown__request pt-0"
                      v-click-outside="toggleSourceGeoDropdown"
                      v-if="sourceGeoDropdown"
                    >
                      <div class="dropdown-item search-container-wrapper">
                        <div class="search-container">
                          <v-icon class="icon">mdi-magnify</v-icon>
                          <input
                            type="text"
                            placeholder="Start typing"
                            v-model="searchSourceGeoDropdown"
                          >
                        </div>
                      </div>
                      <div class="dropdown-list">
                        <div class="dropdown-item"
                          v-for="(item, index) in sourceGeoFiltered"
                          :key="index"
                          @click.prevent="selectSourceGeoDropdownItem(item)"
                        >
                          <div class="dropdown-item--left">
                            <p class="dropdown-item--left--text dropdown-item--left--text--geo">
                              {{ item }}
                            </p>
                          </div>
                          <div class="dropdown-item--right">
                            <v-icon
                              v-if="assignmentForm.sourceGeo === item"
                              size="20"
                              style="margin-left: 3.5px;"
                            >
                              mdi-check
                            </v-icon>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="geos--arrow">
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_arrow_right'"
                      />
                  </div>
                  <div class="d-flex relative flex-shrink-0">
                    <p class="mb-0 assignment-form--geo"
                      @click.prevent="toggleGeoDropdown">
                      {{ assignmentForm.geo ? assignmentForm.geo : 'No Target GEO' }}
                    </p>
                    <div
                      class="assignment-form__header--dropdown dropdown__request pt-0"
                      v-click-outside="toggleGeoDropdown"
                      v-if="geoDropdown"
                    >
                      <div class="dropdown-item search-container-wrapper">
                        <div class="search-container">
                          <v-icon class="icon">mdi-magnify</v-icon>
                          <input type="text" placeholder="Start typing" v-model="searchTargetGeoDropdown">
                        </div>
                      </div>
                      <div class="dropdown-list">
                        <div class="dropdown-item"
                          v-for="(item, index) in geoOptionsFiltered"
                          :key="index"
                          @click.prevent="selectGeoDropdownItem(item)"
                        >
                          <div class="dropdown-item--left">
                            <p class="dropdown-item--left--text dropdown-item--left--text--geo">{{ item }}</p>
                          </div>
                          <div class="dropdown-item--right">
                            <v-icon
                              v-if="assignmentForm.geo === item"
                              size="20"
                              style="margin-left: 3.5px;"
                            >
                              mdi-check
                            </v-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  
                <!-- Tabs -->
                <div class="assignment-form__tabs">
                  <div class="assignment-form__tabs--buttons">
                    <button
                      v-for="(tab, index) in tabs"
                      :key="index"
                      :class="['tab-btn', { active: activeTab === index }]"
                      @click="activeTab = index"
                    >
                      {{ tab.label }}
                    </button>
                  </div>
                  <div class="assignment-form__tabs--content">
                    <div
                      class="tabs-slider"
                      :style="{ transform: `translateX(-${activeTab * 100}%)` }"
                    >
                      <div class="tab-panel" v-for="(tab, index) in tabs" :key="index">
                        <component :is="tab.component"
                          :projectsList="projectsList"
                          :staffList="staffList"
                          :staffHours="staffHours"
                          @assignment-dashboard-table-refresh="$emit('assignment-dashboard-table-refresh')" />
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- Task/Assignment hierarchy — inline on narrow screens, where the
                 right column collapses into the rail below -->
            <div
              v-if="windowWidth <= 1286"
              style="width: 100%;"
              class="animated-section"
              v-show="settingsSection === 'Hierarchy'"
            >
              <ADFormHierarchy
                :taskDbId="assignmentForm.taskDbId"
                :taskId="assignmentForm.taskId"
                :taskName="assignmentForm.taskName"
                :currentAssignmentId="assignmentForm.id"
                @select-assignment="handleHierarchySelect"
              />
            </div>
            <div
              v-if="windowWidth <= 1286"
              style="width: 100%;"
              class="animated-section"
              v-show="settingsSection === 'Activity'"
            >
              <ADFormActivity
                :key="`activity-inline-${formActivityUpdate}`"
                :assignmentId="assignmentForm.id"
              />
            </div>

            <!-- section rail (narrow screens) -->
            <div
              v-if="windowWidth <= 1286"
              class="assignment-form__assignment--settings"
            >
              <div
                class="assignment-form__assignment--settings--button mt-3"
                @click="settingsSection = 'Details'"
              >
                <div
                  class="assignment-form__assignment--settings--button-icon"
                  :style="settingsSection === 'Details' ? { backgroundColor: '#7575754D' } : { backgroundColor: '#FFF' }"
                >
                  <pmdashboard_table_icons :icon="'pmdashboard_details2'" />
                </div>
                <p class="mb-0 settings--text">Details</p>
              </div>
              <div
                class="assignment-form__assignment--settings--button mt-3"
                @click="settingsSection = 'Activity'"
              >
                <div
                  class="assignment-form__assignment--settings--button-icon"
                  :style="settingsSection === 'Activity' ? { backgroundColor: '#7575754D' } : { backgroundColor: '#FFF' }"
                >
                  <pmdashboard_table_icons :icon="'pmdashboard_activity'" />
                </div>
                <p class="mb-0 settings--text">Activity</p>
              </div>
              <div
                class="assignment-form__assignment--settings--button mt-3"
                @click="settingsSection = 'Hierarchy'"
              >
                <div
                  class="assignment-form__assignment--settings--button-icon"
                  :style="settingsSection === 'Hierarchy' ? { backgroundColor: '#7575754D' } : { backgroundColor: '#FFF' }"
                >
                  <ad_form_icons :icon="'hierarchy'" />
                </div>
                <p class="mb-0 settings--text">Hierarc.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- right column: panel + section rail (wide screens) -->
        <div
          v-if="windowWidth > 1286"
          class="d-flex assignment-form__assignment--right"
          style="width: 420px;"
        >
          <div class="assignment-form__assignment--right--panel">
            <ADFormHierarchy
              v-show="rightPanelSection === 'Hierarchy'"
              ref="hierarchyPanel"
              class="animated-section"
              :taskDbId="assignmentForm.taskDbId"
              :taskId="assignmentForm.taskId"
              :taskName="assignmentForm.taskName"
              :currentAssignmentId="assignmentForm.id"
              @select-assignment="handleHierarchySelect"
            />
            <ADFormActivity
              v-show="rightPanelSection === 'Activity'"
              :key="`activity-panel-${formActivityUpdate}`"
              class="animated-section"
              :assignmentId="assignmentForm.id"
            />
          </div>
          <div class="assignment-form__assignment--settings assignment-form__assignment--settings--right">
            <div
              class="assignment-form__assignment--settings--button mt-3"
              @click="rightPanelSection = 'Activity'"
            >
              <div
                class="assignment-form__assignment--settings--button-icon"
                :style="rightPanelSection === 'Activity' ? { backgroundColor: '#7575754D' } : { backgroundColor: '#FFF' }"
              >
                <pmdashboard_table_icons :icon="'pmdashboard_activity'" />
              </div>
              <p class="mb-0 settings--text">Activity</p>
            </div>
            <div
              class="assignment-form__assignment--settings--button mt-3"
              @click="rightPanelSection = 'Hierarchy'"
            >
              <div
                class="assignment-form__assignment--settings--button-icon"
                :style="rightPanelSection === 'Hierarchy' ? { backgroundColor: '#7575754D' } : { backgroundColor: '#FFF' }"
              >
                <ad_form_icons :icon="'hierarchy'" />
              </div>
              <p class="mb-0 settings--text">Hierarc.</p>
            </div>
          </div>
        </div>
      </div>
    </v-container>

    <!-- leaving the open assignment for a sibling would drop unsaved edits -->
    <v-dialog
      max-width="500"
      v-model="switchConfirmation"
      @click:outside="cancelHierarchySwitch"
      @keydown.esc="cancelHierarchySwitch"
    >
      <div class="assignment-form__confirmation-modal">
        <p class="assignment-form__confirmation-modal--title">Discard changes?</p>
        <p class="assignment-form__confirmation-modal--text">
          There are unsaved changes on this assignment. Opening another assignment
          from the hierarchy will discard them.
        </p>
        <div class="assignment-form__confirmation-modal--buttons d-flex align-center justify-end">
          <v-btn
            text
            class="assignment-form__confirmation-modal--buttons-continue mr-2"
            @click="cancelHierarchySwitch"
          >
            Continue Editing
          </v-btn>
          <v-btn
            depressed
            color="#FF5252"
            class="assignment-form__confirmation-modal--buttons-discard"
            @click="confirmHierarchySwitch"
          >
            Discard Changes
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import pmdashboard_table_icons from "@/assets/icons/pmdashboard_table_icons.vue";
import { getStaffHoursByAssignmentId, getAssignmentById, getOneProject } from "@/utils/newDbUtils.js";
import { parseAssignmentResponse } from "@/utils/assignmentUtils.js";
import {
  validateAssignmentForm,
  saveAssignmentForm,
  notifyAssignmentSaved,
  syncParentTaskStatus,
} from "@/utils/assignmentFormUtils.js";
import {
  uploadAndAttachDocuments,
  detachAssignmentDocument,
} from "@/utils/assignmentDocumentUtils.js";

import ad_form_icons from "@/assets/icons/ad_form_icons.vue";

import MainTab from "./ADFormComponents/MainTab.vue";
import DubEditorTab from "./ADFormComponents/DubEditorTab.vue";
import NotesAndFilesTab from "./ADFormComponents/NotesAndFilesTab.vue";
import DeliverablesTab from "./ADFormComponents/DeliverablesTab.vue";
import ADFormHierarchy from "./ADFormComponents/ADFormHierarchy.vue";
import ADFormActivity from "./ADFormComponents/ADFormActivity.vue";

export default {
  name: "ADForm",

  components: {
    pmdashboard_table_icons,
    ad_form_icons,
    MainTab,
    DubEditorTab,
    NotesAndFilesTab,
    DeliverablesTab,
    ADFormHierarchy,
    ADFormActivity
  },

  props: {
    staffList: {
      type: Array,
      required: true
    },
    // The dashboard row the form was opened from — used by the Slack shortcut.
    itemToEdit: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      staffHours: [],
      headerDropdownState: false,
      requestTypeDropdown: false,
      assignmentTypeDropdown: false,
      sourceGeoDropdown: false,
      geoDropdown: false,
      searchTargetGeoDropdown: '',
      searchSourceGeoDropdown: '',
      // Which of the three ids the header shows; the values themselves come off
      // the form (see the headerDropdown computed).
      headerIdShown: 'Cue Task ID',
      activeTab: 0,
      tabs: [
        { label: "MAIN 📋", component: "MainTab" },
        { label: "NOTES & FILES 📁", component: "NotesAndFilesTab" },
        { label: "DUBEDITOR ✍️", component: "DubEditorTab" },
        { label: "DELIVERABLES 📦", component: "DeliverablesTab" },
      ],
      isEditing: [],
      isHovered: [],
      windowWidth: window.innerWidth,
      assignmentSettingsMenu: false,
      createdDate: null,
      updatedDate: null,
      createAssignmentLoader: false,
      settingsSection: 'Details',
      // Right column (wide screens) — the rail switches between the assignment's
      // activity and the Task/Assignment hierarchy.
      rightPanelSection: 'Hierarchy',
      // Bumped after a successful save so the activity panel remounts and reads
      // the rows that save just wrote (same mechanism as the task form).
      formActivityUpdate: 0,
      // Serialized form as it was loaded, so leaving for a sibling assignment
      // can warn before dropping edits.
      loadedFormSnapshot: null,
      switchConfirmation: false,
      pendingAssignmentId: null,
      minHeight: 190,
      minWindowHeight: 330,
    };
  },

  computed: {
    ...mapGetters("assignment", [
      "geoOptions",
      "mediaTypeOptions",
      "requestTypeOptions",
      "projectsList",
      "assignmentForm",
      "relatedWriters",
      "relatedEditors",
      "reviewers"
    ]),
    ...mapGetters("auth", ["user"]),
    dynamicHeightStyle() {
      const windowHeight = window.innerHeight;
      const calculatedHeight = Math.max(this.minHeight, windowHeight - (this.minWindowHeight - this.minHeight));
      return {
        height: `${calculatedHeight}px`,
      };
    },
    geoOptionsFiltered() {
      return this.geoOptions.filter(item => item.toLowerCase().includes(this.searchTargetGeoDropdown.toLowerCase()));
    },
    sourceGeoFiltered() {
      return this.geoOptions.filter(item => item.toLowerCase().includes(this.searchSourceGeoDropdown.toLowerCase()));
    },
    // An assignment that already exists on the server is being edited; a form
    // with no id is still a draft. Derived from the record itself so the header,
    // the Publish/Update button and the save verb can never disagree.
    gIsEditing() {
      return !!this.assignmentForm.id;
    },
    // True once the form differs from what was loaded. Drives both the
    // [UNSAVED CHANGES] badge and the hierarchy's sibling-switch warning.
    hasUnsavedChanges() {
      if (!this.loadedFormSnapshot) return false;
      return this.loadedFormSnapshot !== this.serializeForm();
    },
    checkIfFieldUpdated() {
      return this.hasUnsavedChanges;
    },
    // The three ids the header can show. Values are read off the form, so they
    // fill in as soon as an assignment is loaded or saved.
    headerDropdown() {
      return [
        {
          title: 'Cue Task ID',
          value: this.assignmentForm.taskId,
          show: this.headerIdShown === 'Cue Task ID'
        },
        {
          title: 'Cue Assignment ID',
          value: this.assignmentForm.id,
          show: this.headerIdShown === 'Cue Assignment ID'
        },
        {
          title: 'External Assignment ID',
          value: this.assignmentForm.externalAssignmentId,
          show: this.headerIdShown === 'External Assignment ID'
        },
      ];
    },
    assignmentTitleValue: {
      get() {
        return this.assignmentForm.assignmentTitle
      },
      set(value) {
        this.updateAssignmentData({
          field: 'assignmentTitle',
          data: value
        })
      }
    },
  },

  methods: {
    ...mapActions("assignment", [
      "updateAssignmentData",
      "getStaffByGeo",
      "setAssignmentForm",
      "resetAssignmentForm"
    ]),
    ...mapActions("flashMessage", ["handleFlash"]),
    formatDateForTitle(dateArray) {
      const [year, month, day] = dateArray;
      const date = new Date(year, month - 1, day);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    },
    toggleHeaderDropdown() {
      this.headerDropdownState = !this.headerDropdownState;
    },
    toggleRequestTypeDropdown() {
      this.requestTypeDropdown = !this.requestTypeDropdown;
    },
    toggleAssignmentTypeDropdown() {
      this.assignmentTypeDropdown = !this.assignmentTypeDropdown;
    },
    toggleSourceGeoDropdown() {
      this.sourceGeoDropdown = !this.sourceGeoDropdown;
    },
    toggleGeoDropdown() {
      this.geoDropdown = !this.geoDropdown;
    },
    selectDropdownItem(item) {
      this.headerIdShown = item.title;
      this.headerDropdownState = false;
    },
    selectRequestTypeDropdownItem(item) {
      this.updateAssignmentData({
        field: 'requestType',
        data: item
      });
      this.requestTypeDropdown = false;
    },
    selectSourceGeoDropdownItem(item) {
      this.updateAssignmentData({
        field: 'sourceGeo',
        data: item
      });
      this.sourceGeoDropdown = false;
    },
    selectGeoDropdownItem(item) {
      this.updateAssignmentData({
        field: 'geo',
        data: item
      });
      if (item && this.assignmentForm.relatedProject && this.assignmentForm.relatedProject.name !== 'Empty') this.getStaffByGeo({selectedGeo: item});
      this.geoDropdown = false;
    },
    selectAssignmentTypeDropdownItem(item) {
      this.updateAssignmentData({
        field: 'assignmentType',
        data: item
      });
      this.assignmentTypeDropdown = false;
    },
    // Create (POST) or update (PUT) the assignment, then attach whatever the
    // Notes & Files tab is holding. The record has to exist before the files can
    // be linked to it, so the order here is fixed: save, then upload.
    async publishAssignment() {
      if (this.createAssignmentLoader) return;

      const problems = validateAssignmentForm(this.assignmentForm);
      if (problems.length) {
        this.handleFlash({
          response: {
            data: { statusCode: 400, error: problems.join("\n") },
          },
          show: true,
        });
        return;
      }

      // Grabbed before the save: adopting the server response below rebuilds
      // `documents` from the payload, which only knows about files that are
      // already attached. Without this the files the user just picked would be
      // dropped before they ever go up.
      const pendingDocuments = (this.assignmentForm.documents || []).filter(
        (el) => el?.file && !el.uploaded
      );
      // Stored files the Notes & Files tab dropped. Detached only after the record
      // itself saved, so a failed update never destroys a file.
      const removedDocuments = (this.assignmentForm.removedDocuments || []).filter(
        (el) => el?.id
      );
      // The record stores one link; anything past the first is not persisted.
      const droppedLinks = (this.assignmentForm.links || []).slice(1);

      this.createAssignmentLoader = true;
      try {
        const result = await saveAssignmentForm({ form: this.assignmentForm });

        if (!result.ok) {
          this.handleFlash({
            response: result.response ?? {
              data: {
                statusCode: 500,
                error: "Failed to save the assignment",
              },
            },
            show: true,
          });
          return;
        }

        // Adopt the server's version of the record — the create response carries
        // the new id (and cueTaskId), which the upload and the task sync need —
        // then put the still-pending files back so they can be uploaded.
        if (result.saved) {
          const parsed = parseAssignmentResponse(result.saved);
          // The response predates the detach calls below, so it still lists the
          // files the user removed. They come off here and detachRemovedDocuments
          // puts back any whose removal did not go through.
          const removedIds = removedDocuments.map((el) => el.id);
          parsed.documents = [
            ...parsed.documents.filter((el) => !removedIds.includes(el.id)),
            ...pendingDocuments,
          ];
          this.setAssignmentForm(parsed);
          this.createdDate = result.saved.createdDate ?? this.createdDate;
          this.updatedDate = result.saved.updatedDate ?? this.updatedDate;
        } else if (removedDocuments.length) {
          // Nothing to adopt, so drop the removed rows and clear the queue by
          // hand — otherwise saving again would detach the same files twice.
          const removedIds = removedDocuments.map((el) => el.id);
          this.updateAssignmentData({
            field: "documents",
            data: (this.assignmentForm.documents || []).filter(
              (el) => !removedIds.includes(el.id)
            ),
          });
          this.updateAssignmentData({ field: "removedDocuments", data: [] });
        }

        // A synthetic response rather than the axios one: handleFlash reads
        // `data.statusCode || data.status` first, and the saved assignment has
        // its own fields — FlashMessage would then compare a string against 204
        // and paint a successful save red. Only one message is on screen at a
        // time, so the dropped-link caveat rides along instead of replacing it.
        this.handleFlash({
          response: {
            data: {
              statusCode: 200,
              message: [
                result.isUpdate ? "Assignment updated" : "Assignment created",
                droppedLinks.length
                  ? `— only the first link is stored, not saved: ${droppedLinks.join(", ")}`
                  : "",
              ]
                .filter(Boolean)
                .join(" "),
            },
          },
          show: true,
        });

        // Both of these flash their own outcome, which is why they run after the
        // save message: only one message is on screen at a time, and what happened
        // to the files is the more specific news.
        await this.detachRemovedDocuments(removedDocuments);

        if (result.id && pendingDocuments.length)
          await this.uploadPendingDocuments(result.id);

        // Side effects, in the same shape the legacy form uses. Both swallow
        // their own errors — the assignment is already saved.
        await notifyAssignmentSaved({
          form: this.assignmentForm,
          payload: result.payload,
          assignmentId: result.id,
          isUpdate: result.isUpdate,
        });
        await syncParentTaskStatus({
          cueTaskId: result.saved?.cueTaskId ?? this.assignmentForm.cueTaskId,
          status: result.payload.assignmentDetails.assignmentStatus,
        });

        // Nothing is dirty any more, so the [UNSAVED CHANGES] badge and the
        // hierarchy's discard warning clear.
        this.captureFormSnapshot();
        // The save wrote history rows; remount the panel so it shows them.
        this.formActivityUpdate += 1;
        this.$emit("assignment-saved", result.id);
        this.closeForm();
      } catch (err) {
        console.error("Assignment save error:", err);
        this.handleFlash({
          response: {
            data: {
              statusCode: 500,
              error: err.message || "Failed to save the assignment",
            },
          },
          show: true,
        });
      } finally {
        this.createAssignmentLoader = false;
      }
    },
    // Detach the stored files the Notes & Files tab dropped. The rows are already
    // gone from the form by the time this runs, so a file whose removal did not go
    // through is put back — the list has to show what is actually on the record.
    async detachRemovedDocuments(removedDocuments) {
      if (!removedDocuments.length) return;

      const results = await Promise.all(
        removedDocuments.map(async (document) => {
          try {
            const { ok, error, notSupported } = await detachAssignmentDocument(
              document
            );
            if (ok) return null;
            return {
              document,
              error: notSupported
                ? `${document.fileName} could not be removed — this deployment has no file removal endpoint.`
                : error,
            };
          } catch (err) {
            console.error("Assignment document removal error:", err);
            return {
              document,
              error: err.message || `Failed to remove ${document.fileName}`,
            };
          }
        })
      );

      const failures = results.filter(Boolean);
      if (!failures.length) return;

      this.updateAssignmentData({
        field: "documents",
        data: [
          ...(this.assignmentForm.documents || []),
          ...failures.map((el) => el.document),
        ],
      });
      this.handleFlash({
        response: {
          data: {
            statusCode: 500,
            error: failures.map((el) => el.error).join("\n"),
          },
        },
        show: true,
      });
    },
    // Uploads every document the user added in the Notes & Files tab and
    // connects the stored files to the saved assignment. Documents that are
    // already on the assignment are skipped, so saving twice never re-uploads.
    async uploadPendingDocuments(assignmentId) {
      const documents = this.assignmentForm.documents || [];
      const pendingDocuments = documents.filter((el) => el?.file && !el.uploaded);
      if (!pendingDocuments.length) return;

      // The loader is owned by publishAssignment, which is the only caller.
      try {
        const { attached, failed } = await uploadAndAttachDocuments({
          assignmentId,
          pendingDocuments,
        });
        // Only the files that reached the assignment are marked done; the rest
        // stay pending, so saving again retries just those.
        this.updateAssignmentData({
          field: "documents",
          data: documents.map((el) =>
            attached.includes(el) ? { ...el, file: null, uploaded: true } : el
          ),
        });
        if (failed.length) {
          this.handleFlash({
            response: {
              data: {
                statusCode: 500,
                error: `${attached.length} of ${pendingDocuments.length} files uploaded. Failed: ${failed
                  .map((el) => el.document.fileName)
                  .join(", ")}`,
              },
            },
            show: true,
          });
        } else {
          this.handleFlash({
            response: {
              data: {
                statusCode: 200,
                message: `${attached.length} file(s) uploaded`,
              },
            },
            show: true,
          });
        }
      } catch (err) {
        console.error("Assignment document upload error:", err);
        // Keep the documents pending so the user can save again and retry.
        this.handleFlash({
          response: {
            data: {
              statusCode: 500,
              error: err.message || "Failed to upload the assignment files",
            },
          },
          show: true,
        });
      }
    },
    openSlackForm(item) {
      console.log('openSlackForm', item);
    },
    closeForm() {
      this.$emit("close-assignment-form");
    },
    serializeForm() {
      try {
        return JSON.stringify(this.assignmentForm);
      } catch (err) {
        return null;
      }
    },
    // Snapshot the form once it is fully populated — anything typed after this
    // point counts as an unsaved change.
    captureFormSnapshot() {
      this.$nextTick(() => {
        this.loadedFormSnapshot = this.serializeForm();
      });
    },
    // A node was clicked in the hierarchy panel: confirm first when the current
    // assignment has edits, otherwise hand the id to the dashboard to route to.
    handleHierarchySelect(assignmentId) {
      if (!assignmentId) return;
      if (String(assignmentId) === String(this.assignmentForm.id)) return;
      if (this.hasUnsavedChanges) {
        this.pendingAssignmentId = assignmentId;
        this.switchConfirmation = true;
        return;
      }
      this.$emit("select-assignment", assignmentId);
    },
    cancelHierarchySwitch() {
      this.switchConfirmation = false;
      this.pendingAssignmentId = null;
    },
    confirmHierarchySwitch() {
      const assignmentId = this.pendingAssignmentId;
      this.switchConfirmation = false;
      this.pendingAssignmentId = null;
      if (assignmentId) this.$emit("select-assignment", assignmentId);
    },
    openSettingsMenu() {
      this.assignmentSettingsMenu = true;
    },
    closeSettingsMenu() {
      this.assignmentSettingsMenu = false;
    },
    isHoveredOn(item) {
      if (!this.isHovered.includes(item)) {
        this.isHovered.push(item);
      }
    },
    isHoveredOff(item) {
      if (this.isHovered.includes(item)) {
        this.isHovered = this.isHovered.filter((i) => i !== item);
      }
    },
    startEditing(item) {
      this.isEditing.push(item);
      this.$nextTick(() => {
        this.$refs[item].focus();
      });
    },
    stopEditing(item) {
      if (
        item != "relatedProject" 
        || item != "clientRequester"
        || item != "deliveryDate"
        || item != "requestDate"
      ) {
        this.isEditing = this.isEditing.filter((i) => i !== item);
        this.isHovered = this.isHovered.filter((i) => i !== item);
      }
    },
    deleteAssignmentMenuOpen() {
      /* this.deleteTaskModal = true;
      this.taskSettingsMenu = false; */
    },
    // Copies whichever of the three ids the header is currently showing.
    copyTaskId() {
      const shown = this.headerDropdown.find(item => item.show);
      if (shown?.value) {
        navigator.clipboard.writeText(String(shown.value))
          .then(() => {
            this.handleFlash({ response: {data: {message: "Copied", statusCode: 200}}, show: true });
          })
          .catch(err => {
            console.error('Failed to copy ID:', err);
          });
      } else {
        console.warn('No ID to copy');
      }
    },
    copyAssignmentTitle() {
      if (this.assignmentForm.assignmentTitle) {
        navigator.clipboard.writeText(this.assignmentForm.assignmentTitle)
          .then(() => {
            this.handleFlash({ response: {data: {message: "Copied", statusCode: 200}}, show: true });
          })
          .catch(err => {
            console.error('Failed to copy Name:', err);
          });
      } else {
        console.warn('No Assignment Name to copy');
      }
    },
    updateHeight() {
      this.windowWidth = window.innerWidth;
      this.$forceUpdate();
    },
    syncAssigneesWithStaffList() {
      // The /assignment payload returns primary/secondary/qc as flat user
      // objects ({ id, firstName, ... }), but the assignee selectors are bound
      // to the project's staff objects (with the user nested under `.user`).
      // Swap in the matching staff instance so the current Primary/Secondary/QC
      // render and remain selectable; keep the original value if no match.
      const matchStaff = (list, person) => {
        if (!person) return null;
        const userId = person.user?.id ?? person.id;
        return list.find((el) => el.user?.id === userId) ?? person;
      };
      const primary = matchStaff(this.relatedWriters, this.assignmentForm.primary);
      const secondary = matchStaff(this.relatedEditors, this.assignmentForm.secondary);
      const qc = matchStaff(this.reviewers, this.assignmentForm.qc);
      if (primary !== this.assignmentForm.primary)
        this.updateAssignmentData({ field: "primary", data: primary });
      if (secondary !== this.assignmentForm.secondary)
        this.updateAssignmentData({ field: "secondary", data: secondary });
      if (qc !== this.assignmentForm.qc)
        this.updateAssignmentData({ field: "qc", data: qc });
    },
  },

  async mounted() {
    window.addEventListener('resize', this.updateHeight);
    const id = this.$route.query.openAssignmentForm;
    if (id) {
      const response = await getAssignmentById(id);
      const parsedData = parseAssignmentResponse(response);
      this.setAssignmentForm(parsedData);
      // Feeds the "Created on … last edited …" line in the title bar.
      this.createdDate = response?.createdDate ?? null;
      this.updatedDate = response?.updatedDate ?? null;
      // Enrich the related project with its staff / client requesters / purchase
      // orders so the Primary, Secondary, QC, Client Requester and PO selectors
      // have options to choose from (the /assignment payload omits these lists).
      const relatedProject = this.assignmentForm.relatedProject;
      if (relatedProject?.id && !relatedProject.staff) {
        const projectResp = await getOneProject(relatedProject.id);
        if (projectResp?.data) {
          this.updateAssignmentData({ field: "relatedProject", data: projectResp.data });
        }
      }
      // Populate the assignee option lists for the currently selected target GEO,
      // then reconcile the loaded Primary/Secondary/QC with those lists.
      if (this.assignmentForm.geo && this.assignmentForm.relatedProject?.staff?.length) {
        this.getStaffByGeo({ selectedGeo: this.assignmentForm.geo });
        this.syncAssigneesWithStaffList();
      }
    }
    if (this.assignmentForm && this.assignmentForm.id) {
      try {
        const resp = await getStaffHoursByAssignmentId(this.assignmentForm.id);
        if (resp.status === 200) {
          let hours = resp.data.filter(el => (el.staffId === this.user.user.id) || this.user.user.userRole !== 'STAFF');
          hours.length && hours.forEach((el) => {
            this.staffHours.push(
              ...el.workTime,
            );
          })
          this.staffHours.length && this.staffHours.forEach(el => {
            el.status = hours[0].status;
            el.staffHoursId = hours[0].id;
          })
        };
      } catch (error) {
        console.error(error);
      }
    }
    this.captureFormSnapshot();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeight);
    // wipe the form state so the next time the modal opens it starts empty
    // (an existing assignment is re-fetched and re-populated in mounted())
    this.resetAssignmentForm();
  }
};
</script>

<style lang="scss" scoped>
  .assignment-form {
    font-family: 'Roboto', sans-serif !important;
    border-radius: 15px !important;
    position: relative;
    min-height: 90vh;
    max-height: 90vh;
    // Fill the dialog instead of demanding 90vw: the dialog is capped at
    // 1720px, so on wide screens 90vw was wider than its own container and
    // pushed a horizontal scrollbar onto the modal.
    width: 100%;
    // Each column scrolls on its own, so the card itself never shows a
    // scrollbar in either direction.
    overflow: hidden;
    &__header {
      &--dropdown {
        position: absolute;
        top: 28px;
        height: 150px;
        width: 300px;
        background-color: #fff;
        padding: 10px 5px;
        gap: 8px;
        box-shadow: 0px 1px 6px 2px #00000026;
        border-radius: 10px;
        z-index: 20;
        & .dropdown-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          padding: 0 8px;
          cursor: pointer;
          .search-container {
            display: flex;
            align-items: center;
            background-color: #f8f9fa;
            border: 1px solid #EDEFF3;
            border-radius: 8px;
            width: 320px;
            height: 36px;
            margin-bottom: 8px;
          }
          .search-container input {
            border: none;
            outline: none;
            background: none;
            flex: 1;
            padding: 8px;
            font-size: 16px;
            color: #697A9B;
          }
          .search-container .icon {
            color: #a0a0a0;
            margin-right: 10px;
            margin-left: 12px;
            font-size: 20px;
            width: 16px;
            height: 16px;
          }
          &--left {
            display: flex;
            flex-direction: column;
            width: 80%;
            &--text {
              font-family: 'Inter';
              font-weight: 500;
              font-size: 14px;
              line-height: 16px;
              letter-spacing: 0px;
              margin: 0 0 4px 0;
              color: #656F7D80;
              &.dropdown-item--left--text--geo {
                color: #292a2c !important;
              }
            }
            &--value {
              display: flex;
              & .assignment-form--id--button {
                font-size: 14px;
                width: 14px;
                height: 14px;
              }
              &--text {
                font-family: 'Roboto';
                font-weight: 600;
                font-size: 16px;
                line-height: 18px;
                vertical-align: middle;
                color: #93979D;
                margin: 0;
              }
            }
          }
          &--right {
            width: 20%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color: #B1B6BD;
          }
        }
        & .dropdown-item.search-container-wrapper {
          flex: 0 0 auto;
          position: sticky;
          top: 0;
          background: white;
          z-index: 10;
          padding: 8px 0 0 0;
        }
        & .dropdown-list {
          flex: 1;
          overflow-y: auto;
        }
        &.dropdown__request {
          height: 250px !important;
          overflow-y: auto;
          z-index: 100 !important;
          position: absolute !important;
            &::-webkit-scrollbar {
              width: 10px;
            }

            &::-webkit-scrollbar-track {
              background: #f1f1f1;
            }

            &::-webkit-scrollbar-thumb {
              background: #ADB3BD;
              border-radius: 8px;
            }

            &::-webkit-scrollbar-thumb:hover {
              background: #ADB3BD;
            }

            & {
              scrollbar-width: thin;
              scrollbar-color: #ADB3BD #f1f1f1;
            }
        }
      }
    }
    &__title {
      font-family: 'Roboto', sans-serif !important;
      border-bottom: 1px solid #e0e0e0;
      min-height: 50px;
      padding: 0 20px;
      p {
        margin: 0;
      }
      &--left {
        font-size: 16px !important;
        font-weight: 600;
        color: #656F7D !important;
      }
      &--right {
        min-width: 40%;
        justify-content: flex-end;
        &--text {
          font-size: 14px !important;
          font-weight: 300;
          color: #656F7D;
        }
        &--publish {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4px;
          background-color: #1976D2;
          border-radius: 5px;
          color: #FFFFFF;
          font-weight: 400;
          font-size: 16px;
          font-family: 'Roboto', sans-serif !important;
          line-height: 18px;
          opacity: 0.9;
          &:hover {
            cursor: pointer;
            opacity: 1;
          }
        }
        &--delimetr {
          width: 1px;
          height: 20px;
          background-color: #e0e0e0;
        }
        &--icon {
          width: 22px;
          height: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        &--close {
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover {
            cursor: pointer;
          }
        }
        &--menu {
          position: absolute;
          width: 186px;
          height: 52px;
          padding: 10px 5px 10px 5px;
          border-radius: 10px;
          background: #FFFFFF;
          top: 25px;
          right: 0px;
          box-shadow: 0px 1px 6px 2px #00000026;
          z-index: 20;
          display: flex;
          flex-direction: column;
          justify-content: center;
          &--items {
            padding: 8px 5px 8px 5px;
            border-radius: 4px;
            & p {
              color: #697A9B;
              font-family: 'Roboto', sans-serif !important;
              font-size: 14px;
              font-weight: 500;
              margin-bottom: 0;
              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    &__assignment {
      &--title {
        padding: 25px 35px;
        & .assignment-form {
          &--id {
            font-size: 16px !important;
            font-weight: 600;
            color: #93979D !important;
            margin-bottom: 0px;
            &--text {
              font-size: 16px !important;
              font-weight: 600;
              color: #656F7D80 !important;
              min-width: 100px;
              margin-bottom: 0px;
            }
            &--button {
              min-width: 15px;
              padding: 0 5px;
            }
          }
          &--title {
            height: 45px;
            &--div {
              font-size: 26px;
              font-weight: 600;
              margin-bottom: 4px;
            }
            &--button {
              min-width: 15px;
              padding: 0 5px;
            }
          }
          &--dri {
            display: flex;
            align-items: center;
            &--text {
              font-size: 16px !important;
              font-weight: 600 !important;
              font-family: 'Roboto', sans-serif !important;
              color: #656F7D;
              margin-bottom: 0px;
            }
            &--circle {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: #7C99E2;
              margin-left: 6px;
              margin-right: 6px;
            }
            &--name {
              font-size: 16px !important;
              font-weight: 400 !important;
              color: #000000;
              font-family: 'Roboto', sans-serif !important;
              margin-bottom: 0px;
              &-dash {
                margin: 0;
                margin-left: 6px;
                font-family: Roboto;
                font-size: 16px;
                font-weight: 600;
                color: #B4B4B4 !important;
              }
            }
          }
        }
      }
      &--delimetr-horizontal {
        height: 1px;
        width: calc(100% - 20px);
        background-color: #e0e0e0;
      }
      &--content {
        padding: 0 35px;
        &--assignments {
          &-text {
            font-family: 'Roboto', sans-serif !important;
            font-size: 16px !important;
            font-weight: 400 !important;
            line-height: 18px !important;
            text-align: left !important;
            color: #B4B4B4 !important;
          }
        }
        
        &-left {
          // Flex child: without this, long field values could push the details
          // column past its calc() width and shove the right panel off screen.
          min-width: 0;
          &--text {
            font-size: 16px;
            color: #656F7D;
            margin-bottom: 0px;
            width: 100% !important;
            & .user-status-name {
              display: flex;
              align-items: center;
              &-initials {
                min-width: 36px;
                height: 36px;
                font-size: 16px;
                font-weight: 400;
                color: #fff;
                border-radius: 50%;
                background-color: #9747FF;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              &-text {
                color: #000;
                font-size: 16px !important;
                font-weight: 400 !important;
                font-family: 'Roboto', sans-serif !important;
                & a {
                  color: #0000EE !important;
                }
              }
            }
            & .user-status-pending {
              &-container {
                border: 2px dashed #656F7D;
                color: #656F7D !important;
                padding: 8px 5px;
                width: 80px;
                height: 32px;
                border-radius: 15px;
                font-size: 16px !important;
                font-weight: 400 !important;
                font-family: Roboto !important;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
          &--chips-item {
            font-family: Roboto, sans-serif !important;
            font-size: 16px !important;
            font-weight: 500 !important;
            line-height: 18px !important;
            text-align: left !important;
            border-radius: 5px !important;
            &:hover {
              cursor: pointer;
            }
          }
          &--chip {
            color: #fff !important;
            height: 27px !important;
            margin-left: 8px !important;
          }
          &--autocomplete {
            max-width: 133px;
            font-size: 14px !important;
            & .v-input__control {
              & .v-input__slot {
                max-height: 23px !important;
                padding: 0 !important;
              }
            }
          }
          &--dropdown {
            display: inline-block;
            position: relative;
            width: 180px;
            border-radius: 5px;
            .dropdown-wrapper {
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-radius: 5px;
              padding: 4px;
              cursor: pointer;
            }
            .dropdown-text {
              flex-grow: 1;
              font-size: 16px;
              font-weight: 400;
              color: #656F7D !important;
              font-family: 'Roboto', sans-serif !important;
            }
            .dropdown-arrow {
              background-color: transparent;
              border: none;
              cursor: pointer;
              background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>');
              background-repeat: no-repeat;
              background-position: center;
              background-size: 12px 12px;
              width: 20px;
              height: 20px;
            }
            .dropdown-menu {
              position: absolute;
              top: 100%;
              left: 0;
              right: 0;
              margin: 0;
              padding: 0;
              list-style: none;
              background-color: #fff;
              border: 1px solid #ccc;
              border-radius: 4px;
              max-height: 200px;
              min-width: 200px;
              overflow-y: auto;
              z-index: 1000;
            }
            .dropdown-menu li {
              padding: 10px;
              cursor: pointer;
            }
            .dropdown-menu li:hover {
              background-color: #f0f0f0;
            }
            .background-color {
              background-color: #E8E8E8 !important;
            }
          }
        }
      }
      &--settings {
        width: 60px !important;
        min-height: calc(100% - 200px) !important;
        padding: 10px 8px 0 8px !important;
        border-left: 1px solid #E8EAED !important;
        flex-shrink: 0;
        &--right {
          // In the right column the rail runs the full height of the panel.
          min-height: 100% !important;
        }
        &--button {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 44px;
          height: 44px;
          &:hover {
            cursor: pointer;
          }
          &-icon {
            width: 25px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            padding: 2px;
          }
          & .settings--text {
            font-family: Roboto;
            // Smaller than the PM Dashboard rail so the labels fit the 44px
            // button without wrapping.
            font-size: 11px;
            line-height: 14px;
            font-weight: 400;
            color: #757575;
            white-space: nowrap;
          }
        }
      }
      &--right {
        border-left: 1px solid #E0E0E0;
        flex-shrink: 0;
        overflow: hidden;
        // Takes whatever the 60px rail and the 1px border leave, so the column
        // is exactly 420px wide and nothing spills sideways.
        &--panel {
          flex: 1 1 auto;
          min-width: 0;
        }
        &--placeholder {
          width: 100%;
          height: 80vh;
          display: flex;
          align-items: center;
          justify-content: center;
          & p {
            font-family: Roboto;
            font-size: 16px;
            font-weight: 400;
            line-height: 18px;
            text-align: center;
            color: #B4B4B4;
          }
        }
      }
    }
    &__confirmation-modal {
      background-color: #fff !important;
      width: 500px !important;
      display: flex;
      flex-direction: column;
      padding: 30px;
      border-radius: 10px;
      &--title {
        font-family: 'Roboto', sans-serif !important;
        font-size: 20px;
        font-weight: 500;
        color: #656F7D;
        margin-bottom: 10px;
      }
      &--text {
        font-family: 'Roboto', sans-serif !important;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: #757575;
        margin-bottom: 20px;
      }
      &--buttons {
        &-continue {
          color: #757575 !important;
          text-transform: none !important;
        }
        &-discard {
          color: #FFF !important;
          text-transform: none !important;
        }
      }
    }
    &__tabs {
      width: 100%;
      margin-top: 30px;
      &--buttons {
        display: flex;
        gap: 10px;
        margin-bottom: 15px;
      }
      .tab-btn {
        padding: 10px 16px;
        border: none;
        background: transparent;
        cursor: pointer;
        transition: 0.45s;
        font-family: 'Roboto', sans-serif !important;
        font-weight: 500;
        font-size: 14px;
        text-transform: uppercase;
        color: #0000008A;
        border-bottom: 2px solid transparent;
      }

      .tab-btn.active {
        background: transparent;
        color: #1976D2;
        border-bottom: 2px solid #1976D2;
      }
      &--content {
        width: 100%;
        overflow: hidden;
        position: relative;
      }
      .tabs-slider {
        display: flex;
        width: 100%;
        transition: transform 0.35s ease-in-out;
      }
      .tab-panel {
        width: 100%;
        flex-shrink: 0;
        padding: 10px 0;
      }
    }
    &--geo {
      background-color: #E1E1E1;
      height: 18px;
      padding: 2px 3px;
      border-radius: 5px;
      font-family: "Roboto", sans-serif;
      font-weight: 600;
      font-size: 16px;
      color: #656F7D;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .assignment-form__clear {
    width:16px;
    height: 16px;
    padding: 4px;
    border-radius: 2px;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 9000 !important;
    position: absolute !important;
    &--title {
      top: 50%;
      transform: translateY(-45%);
      right: 15px;
    }
    &:hover {
      background-color: #DEDEDE;
      cursor: pointer;
    }
    &--employer {
      top: 50%;
      transform: translateY(-45%);
      right: 6px !important;
    }
  }

  .input-field {
    border: none;
    outline: none;
    width: 100% !important;
    background-color: #F2F2F2;
    padding: 2px 5px;
    &-assignmentTitle {
      padding: 2px 0;
      font-size: 26px;
      font-weight: 600;
    }
    &-idNumber {
      font-size: 16px !important;
      font-weight: 600 !important;
      padding: 0;
      color: #656F7D !important;
    }
  }

  .bradius-4 {
    border-radius: 4px !important;
  }

  // Lays the details column and the right panel side by side (same rule the
  // PM Dashboard task form uses for its two-column layout).
  .row-styles {
    display: flex !important;
    flex-direction: row !important;
  }

  .animated-section {
    animation: fadeIn 0.9s ease forwards;
    opacity: 1;
    transition: opacity 0.9s ease, transform 0.9s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  // The details column scrolls inside itself so the modal never does — same
  // rule as the PM Dashboard task form.
  .scrollable-col {
    height: 80vh !important;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative !important;

    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      background: #ADB3BD;
      border-radius: 8px;
    }
    & {
      scrollbar-width: thin;
      scrollbar-color: #ADB3BD #f1f1f1;
    }
  }

  .geos--arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 18px;
    margin: 0 4px;
  }
</style>